export default {"src":"/_next/static/media/roadwise-warranty-logo-dark-en.d6326502.svg","height":46,"width":109,"blurWidth":0,"blurHeight":0};